import { useGetProductNewsQuery } from "../../../redux/services/broditWebApi"
import {
    desktopBreakpoint, midSizeBreakpoint, mobileBreakpoint, mobileMenuBreakpoint
} from "../../../lib/helper/viewportHelper"
import { strings as Localization } from "../../../lib/Localization"
import defaultTheme from "../../../theme"
import { useSteering } from "../../../redux/hook/userHooks"
import React, { useState } from "react"
import { styled } from "@mui/styles"
import { Link } from "react-router-dom"
import { useMediaQuery } from "@mui/material"
import CircularProgress from "@mui/material/CircularProgress"

const PageWrapper = styled("div")((() => ({
    display: "flex",
    width: "100%",
    justifyContent: "center",
    paddingBottom: "20px"
})))

const Wrapper = styled("div")((() => ({
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    maxWidth: "1110px",
    flex: "0 1 100%"
})))

const Grid = styled("div")((({ theme, list }) => ({
    display: "grid",
    flex: "0 1 100%",
    gridTemplateColumns: "350px 350px 350px",
    justifyContent: "center",
    gap: "20px",
    [theme.breakpoints.down(midSizeBreakpoint)]: {
        gridTemplateColumns: "300px 300px 300px",
        justifyContent: "center",
        gap: "20px"
    },
    [theme.breakpoints.down(mobileMenuBreakpoint)]: {
        gridTemplateColumns: list ? "345px 345px" : "345px",
        justifyContent: "center",
        gap: "30px"
    },
    [theme.breakpoints.down(mobileBreakpoint)]: {
        gridTemplateColumns: "345px"
    },
    [theme.breakpoints.down(390)]: {
        gridTemplateColumns: "100%"
    }
})))

const Title = styled("h2")((() => ({
    flex: "0 1 100%",
    fontSize: "30px",
    textAlign: "center",
    fontFamily: "Rubik",
    fontWeight: 500,
    lineHeight: "40px"
})))

const CardWrapper = styled("a")((() => ({
    display: "flex",
    overflow: "hidden",
    boxShadow: "rgba(45, 45, 45, 0.1) 0px 0px 20px 0px",
    borderRadius: "6px",
    flexDirection: "column",
    textDecoration: "none",
    backgroundColor: "#FFFFFF"
})))

const ImageWrapper = styled("div")((() => ({
    display: "flex",
    flex: "0 1 188px",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#FFFFFF"
})))

const TextWrapper = styled("div")((() => ({
    display: "flex",
    flex: "1 0 auto",
    padding: "10px 20px 20px 20px",
    flexDirection: "column",
    backgroundColor: "#FFFFFF"
})))

const CardTitle = styled("div")((() => ({
    fontSize: "20px",
    fontFamily: "Rubik",
    fontWeight: 400,
    lineHeight: "32px",
    color: "#2d2d2d"
})))

const CardText = styled("div")((() => ({
    fontSize: "16px",
    fontFamily: "Rubik",
    fontWeight: 400,
    lineHeight: "32px",
    color: "#2d2d2d"
})))

const CardImage = styled("img")((() => ({
    width: "350px",
    height: "220px",
    objectFit: "contain",
    maxWidth: "100%",
    maxHeight: "100%"
})))

const ShowMoreWrapper = styled("div")((() => ({
    display: "flex",
    flex: "0 1 100%",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center"
})))

const CreatedDateWrapper = styled("div")((() => ({
    display: "flex",
    flex: "0 1 auto",
    justifyContent: "flex-end",
    fontFamily: "Rubik",
    fontSize: "12px",
    padding: "5px",
    color: "#2d2d2d"
})))

const CreatedDate = styled("div")((() => ({
    padding: "5px",
    borderRadius: "5px"
})))

const ShowMoreAnchor = styled(Link)((({ theme }) => ({
    position: "relative",
    fontFamily: "Rubik",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "16px",
    letterSpacing: "0.5px",
    textAlign: "left",
    color: "#2D2D2D",
    textDecoration: "none",
    marginTop: "30px",
    display: "inline-block",
    [theme.breakpoints.up(desktopBreakpoint)]: {
        "&:after": {
            content: "''",
            position: "absolute",
            width: "100%",
            transform: "scaleX(0)",
            height: "2px",
            bottom: 0,
            left: 0,
            backgroundColor: "#F09057",
            transformOrigin: "bottom right",
            transition: "transform 0.25s ease-out"
        },
        "&:hover:after": {
            transform: "scaleX(1)",
            transformOrigin: "bottom left"
        }
    },
    [theme.breakpoints.down(desktopBreakpoint)]: {
        textDecoration: "2px underline #F09057"
    },
    [theme.breakpoints.down(mobileMenuBreakpoint)]: {
        marginTop: "10px"
    }
})))

const SeeMoreButton = styled("button")((({ theme }) => ({
    display: "none",
    border: 0,
    padding: "6px 8px",
    fontFamily: "Rubik",
    fontWeight: 500,
    fontSize: "14px",
    cursor: "pointer",
    marginTop: "16px",
    backgroundColor: "transparent",
    [theme.breakpoints.down(mobileMenuBreakpoint)]: {
        display: "block"
    }
})))

const MoreButton = styled("button")((() => ({
    backgroundColor: "#F09057",
    padding: "10px 20px 10px 20px",
    borderRadius: "5px",
    border: 0,
    fontFamily: "Rubik",
    fontWeight: 500,
    fontSize: "14px",
    transition: "all 0.1s ease-in",
    cursor: "pointer",
    marginTop: "16px",
    "&:hover": {
        backgroundColor: "#ef7830"
    }
})))

const ModelText = styled("div")((() => ({
    fontFamily: "Arial",
    fontSize: "14px",
    color: "#2d2d2d",
    paddingLeft: "20px",
    paddingRight: "20px",
    paddingBottom: "20px"
})))

const Bottom = styled("div")((() => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    flex: "0 1 100%"
})))

const LoadingWrapper = styled("div")((() => ({
    display: "flex",
    justifyContent: "center",
    flex: "0 1 100%",
    paddingTop: "40px",
    paddingBottom: "40px"
})))

const Spinner = styled(CircularProgress)((() => ({
    width: "100px",
    height: "100px"
})))

const AutomatedNews = ({
    type,
    language,
    limit,
    createdDate = false,
    isListPage = false
}) => {
    const [queryLimit, setQueryLimit] = useState(limit)
    const [expanded, setExpanded] = useState(false)
    const steering = useSteering()
    const { data: news } = useGetProductNewsQuery({
        language: language, limit: queryLimit, type: type, steering: steering === "1" ? "LHD" : "RHD"
    })
    const limitCards = useMediaQuery(defaultTheme.breakpoints.down(mobileMenuBreakpoint))

    const getModelName = compatibleModel => {
        const brand = compatibleModel.brand.name
        const model = compatibleModel.model.name
        const years = compatibleModel.years

        return compatibleModel.category.name === "Vehicles" ? `${brand} ${model} ${years}` : `${brand} ${model}`
    }

    const renderNewsCard = (item, index) => {
        const date = new Date(item.createdDate).toLocaleDateString("en-CA")

        let title = item.productNameTranslation
        let text = item.id
        const compatibleModels = item.compatibleModels?.filter(x => x.brand.name !== ",")

        if (item.compatibleModels && type === "proclip") {
            const compatibleModel = item.compatibleModels[0]

            title = `${compatibleModel.brand.name} ${compatibleModel.model.name} ${compatibleModel.years}`
            text = `${compatibleModel.placement} (${item.id})`
        }

        if (index > 0 && !isListPage && !expanded && limitCards) {
            return null
        }

        return (
            <CardWrapper key={`${type}-${steering}-card-new-${item.id}-${index}`} href={`/${language}/product/${item.id}`}>
                {createdDate
                && (
                    <CreatedDateWrapper>
                        <CreatedDate>
                            {date}
                        </CreatedDate>
                    </CreatedDateWrapper>
                )}
                <ImageWrapper>
                    <CardImage src={`https://www.brodit.com/images/w450/${item.id}.jpg`} />
                </ImageWrapper>
                <Bottom>
                    <TextWrapper>
                        <CardTitle>{title}</CardTitle>
                        <CardText>{text}</CardText>
                    </TextWrapper>
                    {compatibleModels && compatibleModels.length > 0
                        && (
                            <ModelText>
                                {getModelName(compatibleModels[0])}
                                {compatibleModels.length > 1 && Localization.andMore}
                            </ModelText>
                        )}

                </Bottom>
            </CardWrapper>
        )
    }

    return (
        <PageWrapper>
            <Wrapper>
                <Title id="latest-news">{type === "proclip" ? Localization.proclip : Localization.recentlyAddedProducts}</Title>
                {news
                    ? (
                        <Grid list={isListPage ? 1 : undefined}>
                            {news.map((item, i) => renderNewsCard(item, i))}
                        </Grid>
                    )
                    : <LoadingWrapper><Spinner /></LoadingWrapper>}
                <ShowMoreWrapper>
                    {!isListPage
                    && (
                        <SeeMoreButton onClick={() => setExpanded(!expanded)}>
                            {expanded ? Localization.seeLess : Localization.seeMore}
                        </SeeMoreButton>
                    )}
                    {!isListPage
                        ? <ShowMoreAnchor to={`/${language}/news/${type}`}>{Localization.showAllNews}</ShowMoreAnchor>
                        : <MoreButton onClick={() => setQueryLimit(queryLimit + 9)}>{Localization.loadMore}</MoreButton>}
                </ShowMoreWrapper>
            </Wrapper>
        </PageWrapper>
    )
}

export default AutomatedNews
